import { useEffect } from "react"
import toast from "react-hot-toast"
import { Outlet, useNavigate } from "react-router-dom"
import { useHomePath } from "~/common/useHomePath"
import { useCurrentUserMaybe } from "../auth/CurrentUserContext"

export const RequireAdmin = () => {
  const navigate = useNavigate()
  const { currentUser, result } = useCurrentUserMaybe()
  const homePath = useHomePath()

  useEffect(() => {
    if (!currentUser?.isAdmin && !result.loading) {
      toast.error("You are not authorized to view this page.")
      navigate(homePath)
    }
  }, [currentUser, result.loading, navigate, homePath])

  if (result.loading || !currentUser?.isAdmin) {
    return null
  }

  return <Outlet />
}
